import icon from "../../assets/antenna-top.svg";
import type { Property } from "../../types";

export const antennaType: Property = {
  id: "antennaType",
  title: "antennaType.title",
  icon,
};
